import React from 'react';

export interface FieldValidationErrorMessageProps {
  message?: string;
}

export const FieldValidationErrorMessage: React.FC<FieldValidationErrorMessageProps> = ({
  message,
}) => {
  if (!message) return null;
  return (
    <p className="tw:text-stoplight-danger tw:text-sm tw:!mt-2 tw:mb-2">
      <i className="far fa-exclamation-circle tw:text-stoplight-danger tw:mr-1" />
      {message}
    </p>
  );
};
